import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsResultsHttpClient } from './results.http-client';
import { ReportsResultsActions } from './results.store';

@Injectable()
export class ReportsResultsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsResultsHttpClient);
  private readonly store = inject(Store);

  public effects = createEffectFactory(ReportsResultsActions, this.actions$);

  public fetchVisualization$ = this.effects(
    ReportsResultsActions.fetchOneResult,
    ({ payload: { paramsHash, params } }) =>
      this.http.load(params).pipe(
        map(response =>
          ReportsResultsActions.fetchOneResultSuccess({
            payload: {
              paramsHash,
              response,
            },
          }),
        ),
        catchError(err =>
          of(
            ReportsResultsActions.fetchOneResultFailed({
              payload: {
                paramsHash: paramsHash,
                error: {
                  status: err.status,
                  message: err.message,
                },
              },
            }),
          ),
        ),
      ),
    { customMapOperator: mergeMap },
  );
}
